
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"682.667","height":"682.667","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M239 33c-46.7 3.7-91.7 22.2-128 52.7-35.2 29.6-61.6 72.8-72.4 118.3-4.4 18.5-5.8 31-5.8 52 0 36.2 6.7 65.8 22.2 97.5 32.8 67.5 95.6 113.2 170.5 124 15.8 2.3 45.7 2.3 61 .1 49.5-7.4 93.2-29.2 127.6-63.5 34.3-34.4 56-78 63.5-127.6 2.2-14.9 2.2-46.1 0-61C466.1 149 419.9 86.3 350.9 53.6 317.1 37.6 276.4 30.1 239 33zm61.5 132l45.5-45.5 22.7 22.8 22.8 22.7-45.5 45.5-45.5 45.5 45.3 45.3 45.2 45.2-22.7 22.8-22.8 22.7-45.2-45.2-45.3-45.3-45.3 45.3-45.2 45.2-22.8-22.7-22.7-22.8 45.2-45.2 45.3-45.3-45.3-45.3-45.2-45.2 22.7-22.8 22.8-22.7 45.2 45.2 45.3 45.3 45.5-45.5z","fill":"#f44336"}})])
          )
        }
      }
    